import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// AccountPlan
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useModuleList() {
  // Use toast
  const toast = useToast();

  const moduleName = "accountingplan";
  const APP_STORE_MODULE_NAME = "app-" + moduleName;
  const refDataListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "account_number", label: "Compte", sortable: true },
    { key: "account_name", label: "Intitulé", sortable: true },
    { key: "type", label: "Type", sortable: true },
    { key: "account_nature", label: "Nature", sortable: true },
    { key: "actions" },
  ];
  const perPage = ref(5);
  const totalDatas = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [5, 10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(false);
  const attributeFilter = ref(null);
  const accountNatureFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refDataListTable.value
      ? refDataListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDatas.value,
    };
  });

  const refetchData = () => {
    refDataListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery, attributeFilter, accountNatureFilter],
    () => {
      refetchData();
    }
  );

  const fetchModuleAccountPlans = (ctx, callback) => {
    store
      .dispatch(APP_STORE_MODULE_NAME + "/fetchModuleAccountPlans", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        attribute: attributeFilter.value,
        account_nature: accountNatureFilter.value,
      })
      .then((response) => {
        // const { data_list, total } = response.data
        callback(response.data); 
        totalDatas.value = response.totalDatas;
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Erreur chargement liste des données",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveDataNatureVariant = (accountNature) => {
    if (accountNature === "subscriber") return "primary";
    if (accountNature === "manager") return "warning";
    if (accountNature === "maintainer") return "success";
    if (accountNature === "cachier") return "info";
    if (accountNature === "admin") return "danger";
    return "primary";
  };

  const resolveDataNatureIcon = (accountNature) => {
    if (accountNature === "subscriber") return "DataIcon";
    if (accountNature === "manager") return "SettingsIcon";
    if (accountNature === "maintainer") return "DatabaseIcon";
    if (accountNature === "cachier") return "Edit2Icon";
    if (accountNature === "admin") return "ServerIcon";
    return "DataIcon";
  }; 

  return {
    fetchModuleAccountPlans,
    tableColumns,
    perPage,
    currentPage,
    totalDatas,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDataListTable,

    resolveDataNatureVariant,
    resolveDataNatureIcon,
    refetchData,

    // Extra Filters
    attributeFilter,
    accountNatureFilter,
  };
}
